var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.866C16.8094 10.6874 17 10.3573 17 10C17 9.64273 16.8094 9.31261 16.5 9.13398L3 1.33975C2.6906 1.16111 2.3094 1.16111 2 1.33975C1.6906 1.51838 1.5 1.84851 1.5 2.20577L1.5 17.7942C1.5 18.1515 1.6906 18.4816 2 18.6603C2.3094 18.8389 2.6906 18.8389 3 18.6603L16.5 10.866Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.25eaf9a8bcac0aacc2ee28978b2ecbea.svg";
export { ForwardRef as ReactComponent };